import ahoy from "ahoy.js";

function read_cookie(key)
{
    var result;
    return (result = new RegExp('(?:^|; )' + encodeURIComponent(key) + '=([^;]*)').exec(document.cookie)) ? (result[1]) : null;
}

$(document).on('turbolinks:load', function () {

    if (read_cookie("tparea")) {
      console.log("EYY")
        swap_diseasestates(read_cookie("tparea"));
    }
    var slides = [];
    var slideindex = 0;

    function setSlide(number) {
      slideindex = number;
      $("#slide-img img").attr("src", slides[number]);
      $("#slide-status").html("SLIDE "+ (number + 1) + " OF " + slides.length);

    }
    $(".program-info").on('click', function () {
      if ($(this).data("diseasestate").length > 1) {
        force_theme($(this).data("diseasestate"));
      }
      $("#slide-img img").attr("src", '');

        slides = $(this).data("slides");
        setSlide(0);
        //TODO add imgs to container for slides
        $('.program-popup #popup-title').html($(this).data("title"));
        $('.program-popup').show();

    });

    $("#next-button").on('click', function () {

      setSlide((slideindex + 1 ) % slides.length);
    });
    $("#prev-button").on('click', function () {
      setSlide((((slideindex - 1)%slides.length)+slides.length)%slides.length);
    });
    $(".close-popup").on('click', function () {
      $('.popup-container').hide();
    });

    $(".requestbtn").on('click', function() {
      document.cookie = "selected_program" + "=" + $(this).data('id') + ";";
      window.location = "../map";
    });

    function force_theme(diseasestateabrv) {
      $('.themed').removeClass('psych').removeClass('neuro').removeClass('respi');
      $('.themed').addClass(diseasestateabrv);
    }


    function swap_diseasestates(diseasestate) {
        if (diseasestate == "psychiatry") {
            $('.themed').addClass('psych')

        } else if (diseasestate == "respiratory") {
            $('.themed').addClass('respi')

        } else {
            $('.themed').addClass('neuro')
        }
    }
})
